// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-billing-info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.edit-billing-info .stripe-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.edit-billing-info .stripe-elements {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 20px;
  padding: 20px;
}
.edit-billing-info .plan-lock {
  color: #0c923c;
  margin-right: 10px;
}
.edit-billing-info .no-margin-bottom {
  margin-bottom: 0;
}
.edit-billing-info .promo-container {
  display: flex;
  flex-direction: column;
}
.edit-billing-info .pay-promocode {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.edit-billing-info .pay-promocode .button-link {
  display: flex;
  flex-direction: row-reverse;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: right;
  text-decoration: none;
}
.edit-billing-info .pay-promocode .pay-resume-text {
  font-size: 28px;
  font-weight: 700;
  line-height: 40px;
}
.edit-billing-info .pay-text {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  font-size: 12px;
  width: 80%;
}
.edit-billing-info .pay-btn {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.edit-billing-info .cancel-btn {
  margin-right: 20px;
}
.edit-billing-info .plan-lock-instruction {
  color: #6c7275;
  font-size: 12px;
}
.edit-billing-info .paymentinfo-option {
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #000;
}
.edit-billing-info .paymentinfo-option.best-option {
  color: #fff;
  background-color: #000;
}
.edit-billing-info .paymentinfo-option .paymentinfo-periodicity {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 40px;
  letter-spacing: -0.01em;
  color: rgba(108, 114, 117, 0.5);
}
.edit-billing-info .paymentinfo-option .popular-opt {
  gap: 8px;
  background: #ff97e8;
  border-radius: 4px;
  color: #141718;
}
.edit-billing-info .paymentinfo-opt {
  list-style-type: none;
}
.edit-billing-info .periodicity-opt {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}`, "",{"version":3,"sources":["webpack://./src/Components/EditBilling/EditBilling.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AACJ;AAEE;EACE,cAAA;EACA,kBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;AAFJ;AAKE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;AAKI;EACE,aAAA;EACA,2BAAA;EAEA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,qBAAA;AAJN;AAOI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AALN;AAQE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AANJ;AASE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AAPJ;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,cAAA;EACA,eAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAVJ;AAYI;EACE,WAAA;EACA,sBAAA;AAVN;AAaI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,+BAAA;AAXN;AAcI;EACE,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAZN;AAgBE;EACE,qBAAA;AAdJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAfJ","sourcesContent":[".edit-billing-info {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  .stripe-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n  .stripe-elements {\n    display: flex;\n    flex-direction: column;\n    background-color: #fff;\n    border-radius: 20px;\n    padding: 20px;\n  }\n\n  .plan-lock {\n    color: #0c923c;\n    margin-right: 10px;\n  }\n\n  .no-margin-bottom {\n    margin-bottom: 0;\n  }\n\n  .promo-container {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .pay-promocode {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .button-link {\n      display: flex;\n      flex-direction: row-reverse;\n\n      font-family: Inter;\n      font-size: 14px;\n      font-weight: 600;\n      line-height: 24px;\n      letter-spacing: -0.02em;\n      text-align: right;\n      text-decoration: none;\n    }\n\n    .pay-resume-text {\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 40px;\n    }\n  }\n  .pay-text {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 20px;\n    font-size: 12px;\n    width: 80%;\n  }\n\n  .pay-btn {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .cancel-btn {\n    margin-right: 20px;\n  }\n\n  .plan-lock-instruction {\n    color: #6c7275;\n    font-size: 12px;\n  }\n\n  .paymentinfo-option {\n    padding: 20px;\n    border-radius: 20px;\n    border: 1px solid #000;\n\n    &.best-option {\n      color: #fff;\n      background-color: #000;\n    }\n\n    .paymentinfo-periodicity {\n      font-style: normal;\n      font-weight: 700;\n      font-size: 28px;\n      line-height: 40px;\n      letter-spacing: -0.01em;\n      color: rgba(108, 114, 117, 0.5);\n    }\n\n    .popular-opt {\n      gap: 8px;\n      background: #ff97e8;\n      border-radius: 4px;\n      color: #141718;\n    }\n  }\n\n  .paymentinfo-opt {\n    list-style-type: none;\n  }\n\n  .periodicity-opt {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
